export interface IPoiAssignment {
  assignmentAppmarketBundleId?: string;

  assignmentStatus: string;
  assignmentType: string;
  deploymentStatus: string;
  deploymentUninstallStatus: string;
  bundleDeploymentUninstallStatus?: string;
  bundleDeploymentStatus?: string;
  deviceId: string;
  id: string;
}
